export default "__VITE_PUBLIC_ASSET__f04ed05b__"